export default "__VITE_ASSET__ff761ec0__"